// extracted by mini-css-extract-plugin
export default {"wrapper":"NeonText_wrapper__3E1vQ","text":"NeonText_text__KWInc","neon":"NeonText_neon__JSlpF"};